module.exports = __webpack_public_path__ + "img/橙@3x.cebf8c3f.png";